/** Routes du module — propriétaire : Agent A6 — Sauvegardes (simulation). À brancher par A0 dans router.tsx / Layouts.tsx. */
import type { RouteObject } from 'react-router';
import { DatabaseBackup } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { PageSauvegardes } from '../systeme/Sauvegardes';

export const routesAdminSauvegarde: RouteObject[] = [
  { path: 'sauvegardes', element: <RequirePermission permission="sauvegarde.lire"><PageSauvegardes /></RequirePermission> },
];

export const navAdminSauvegarde: EntreeNav[] = [
  { libelle: 'Sauvegardes', vers: '/admin/sauvegardes', permission: 'sauvegarde.lire', icone: DatabaseBackup, groupe: 'Administration' },
];
